/* export const inputGroupPt = () => {
  return {
    root: {
      class: 'font-18-n',
    },
  };
}; */

export const inputGroupConfig = () => {
  return {
    addonColor: 'var(--p-inputtext-color)',
    addonPadding:
      'var(--p-inputtext-padding-y) 0 var(--p-inputtext-padding-y) var(--p-inputtext-padding-x)'
  }
}
